import { Skeleton } from "@mui/material";

export const FilterLoader = () => {
  return (
    <>
      {Array(3)
        .fill(null)
        .map((_, index) => {
          return <Skeleton key={index} />;
        })}
    </>
  );
};
